import { useCallback, useEffect, useSyncExternalStore } from 'react';

/**
 * Enrutador mínimo basado en el «hash» de la dirección (#/suenos, #/biblioteca/b1…).
 * - El botón «atrás» del navegador funciona.
 * - Es compatible con cualquier alojamiento estático (Cloudflare Pages) sin configuración extra.
 */

function leerRuta(): string {
  const h = window.location.hash.replace(/^#/, '');
  return h.startsWith('/') ? h : '/' + h;
}

function suscribir(cb: () => void) {
  window.addEventListener('hashchange', cb);
  return () => window.removeEventListener('hashchange', cb);
}

export function useRuta() {
  const ruta = useSyncExternalStore(suscribir, leerRuta, () => '/');
  const partes = ruta.split('/').filter(Boolean).map(decodeURIComponent);

  const ir = useCallback((destino: string) => {
    if (leerRuta() === destino) return;
    window.location.hash = destino;
  }, []);

  return { ruta, partes, ir };
}

/** Vuelve arriba de la página cada vez que cambia la pantalla. */
export function useArribaAlNavegar(ruta: string) {
  useEffect(() => {
    try { window.scrollTo(0, 0); } catch { /* sin efecto */ }
  }, [ruta]);
}

/** Módulo activo a partir de la ruta (para resaltar la navegación). */
export function moduloDe(partes: string[]): string {
  return partes[0] ?? 'inicio';
}
